module.exports = __webpack_public_path__ + "static/media/fees-bg-img.8b401f9b.png";